import { RouterProvider } from 'react-router-dom'
import { router } from './Router'

export const AppRouterProvider = (): JSX.Element => <RouterProvider router={router} />
